export default __webpack_public_path__ + "7440eb61876f1fac9860be57cca0e906.png";